/* import __COLOCATED_TEMPLATE__ from './copy-records.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();